import { render, staticRenderFns } from "./ButtonPrimaryIconCart.vue?vue&type=template&id=5372624e&scoped=true"
import script from "./ButtonPrimaryIconCart.vue?vue&type=script&lang=js"
export * from "./ButtonPrimaryIconCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372624e",
  null
  
)

export default component.exports